import React from "react";

const NoItemFound: React.FC<{ message?: string }> = ({ message }) => (
  <div
    style={{
      width: "100%",
      textAlign: "center",
      padding: "2rem 0",
      fontWeight: 400,
      fontSize: "16px",
    }}
  >
    {message || "No item found."}
  </div>
);

export default NoItemFound;
